import React from 'react';
import {
  Alert,
  Badge,
  Form,
  Icon,
  Input,
  Button,
  Select,
  Row,
  Col,
  Modal,
  Checkbox, Tooltip
} from 'antd';
import get from 'lodash/get';
import { connect } from 'react-redux';

import {updateRoleRequest, createRoleRequest, toggleActivateRoleRequest} from "../../api/requests";
import {
  getRoleCreatePermission, getRoleDeletePermission,
  getRoleUpdatePermission
} from "../../reducers/user/selectors";

import classes from './SettingsRoleForm.css';
import { logout } from "../../reducers/user/actions";
import fieldsMap from "./fieldsMap";
import classnames from "classnames";

const { Option } = Select;


class SettingsRoleForm extends React.Component {
  constructor(props) {
    super(props);

    const openGroups = {};
    const fieldKeys = Object.keys(fieldsMap);
    fieldKeys.forEach(key => { openGroups[key] = true });

    this.state = {
      isLoading: false,
      requestResult: {},
      deactivateSubmitModal: false,
      roleState: '',
      openGroups,
    };
  }

  componentDidMount() {
    this.setState({ roleState: this.props.state });
  }

  handleSubmit = e => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          const roleRaw = {...values};
          let role = {};

          Object.keys(fieldsMap).forEach(fieldGroupName => {
            get(fieldsMap[fieldGroupName], 'fields', []).forEach(field => {
              if (field.permissions) {
                field.permissions.forEach(permission => {
                  role[`${field.key}_${permission.key}`] = false;
                });
              }
            });
          });

          Object.keys(roleRaw).forEach(roleKey => {
            if (Array.isArray(roleRaw[roleKey])) {
              roleRaw[roleKey].forEach(rolePermission => {
                role[`${roleKey}_${rolePermission}`] = true;
              });
            } else {
              role[roleKey] = roleRaw[roleKey];
            }
          });

          if (this.props.id) {
            await updateRoleRequest(this.props.id , role);
          } else {
            await createRoleRequest(role);
          }

          this.setState({ isLoading: false, requestResult: { type: 'success', message: 'Success' } });

          setTimeout(() => {
            this.props.onSubmit(this.props.id);
          }, 1000);
        } catch (e) {
          if (get(e, 'response.status') === 401) { this.props.logout();  return; }
          this.setState({ isLoading: false, requestResult: { type: 'error', message: get(e, 'response.data.message', 'Error') } });

          if (get(e, 'response.data.errors')) {
            const errors = {};
            Object.keys(get(e, 'response.data.errors')).forEach(errorFieldKey => {
              errors[errorFieldKey] = {
                value: values[errorFieldKey],
                errors: get(e, `response.data.errors.${errorFieldKey}`).map(errorMessage => new Error(errorMessage))
              }
            });
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  showDeactivateModal = () => { this.setState({ deactivateSubmitModal: true }); };
  hideDeactivateModal = () => { this.setState({ deactivateSubmitModal: false }); };

  toggleActivate = async () => {
    try {
      await toggleActivateRoleRequest(this.props.id, this.state.roleState);
      this.setState({ requestResult: { type: 'success', message: 'Success' }, roleState: this.state.roleState === 'inactive' ? 'active' : 'inactive' });
      this.hideDeactivateModal();
      setTimeout(() => {
        this.props.onSubmit(this.props.id);
      }, 1000);
    } catch (e) { if (get(e, 'response.status') === 401) { this.props.logout(); } }
  };

  onCheckAllChange = (fieldGroup, isCheckedAll) => () => {
    fieldsMap[fieldGroup].fields.forEach(field => {
      if (!field.permissions) {
        this.props.form.setFieldsValue({ [field.key]: !isCheckedAll });
      } else {
        this.props.form.setFieldsValue({ [field.key]: isCheckedAll ? [] : field.permissions.map(permission => permission.key) });
      }
    });
  };

  onCheckField = (fieldKey, isCheckedFieldAll, fieldPermissions) => () => {
    this.props.form.setFieldsValue({ [fieldKey]: isCheckedFieldAll ? [] : fieldPermissions.map(permission => permission.key) });
  };

  collapseSection = sectionName => () => {
    this.setState(state =>({ openGroups: {...state.openGroups, [sectionName]: !state.openGroups[sectionName] } }));
  };

  render() {
    const { isLoading, requestResult, deactivateSubmitModal, openGroups } = this.state;
    const { getFieldDecorator } = this.props.form;
    const { roleUpdatePermission, roleCreatePermission, roleDeletePermission, id, isNew, state } = this.props;

    const isEditable = id ? roleUpdatePermission : roleCreatePermission;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className='headline-default'>
            {this.props.id ? (<span>{this.props.name} {state && <Badge count={state} style={{ backgroundColor: state === 'active' ? '#49c850' : '#f00' }} />} <Badge count='Edit' style={{ backgroundColor: '#2968AE' }} /></span>) : isNew ? 'Add role' : ''}
          </h4>

          <Row gutter={12}>
            <Col sm={12}>
              <label>
                <b>Name:</b>
                <Form.Item>
                  {getFieldDecorator('name', {
                    rules: [{ required: true, message: 'Required' }],
                    initialValue: get(this.props, 'name', '')
                  })(
                    <Input disabled={!isEditable} placeholder='Name' />
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col sm={12}>
              <label>
                <b>Description:</b>
                <Form.Item>
                  {getFieldDecorator('description', {
                    rules: [{ required: true, message: 'Required' }],
                    initialValue: get(this.props, 'description', '')
                  })(
                    <Input disabled={!isEditable} placeholder='Description' />
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          {this.props.id && roleDeletePermission && <Row gutter={12}>
            <Col>
              <p>
                <Button type='default' style={{ backgroundColor: this.state.roleState === 'inactive' ? '#44c721' : '#f56009', borderColor: '#fff',  color: '#fff' }} onClick={this.showDeactivateModal}>
                  {this.state.roleState === 'inactive' ? 'Activate' : 'Deactivate'}
                </Button>
              </p>
            </Col>
          </Row>}

          <Row gutter={12}>
            <Col>
              <h4 className='headline-default'>Role settings</h4>

              {Object.keys(fieldsMap).map(fieldGroupName => {
                let isCheckedAll = true;
                let isNotCheckedAll = true;

                fieldsMap[fieldGroupName].fields.some(field => {
                  const value = this.props.form.getFieldValue(field.key);

                  if (Array.isArray(value)) {
                    if (value.length !== field.permissions.length) {
                      isCheckedAll = false;
                      return true;
                    }
                  } else {
                    if (!value) {
                      isCheckedAll = false;
                      return true;
                    }
                  }
                });

                fieldsMap[fieldGroupName].fields.some(field => {
                  const value = this.props.form.getFieldValue(field.key);

                  if (Array.isArray(value)) {
                    if (value.length > 0) {
                      isNotCheckedAll = false;
                      return true;
                    }
                  } else {
                    if (value) {
                      isNotCheckedAll = false;
                      return true;
                    }
                  }
                });

                return (
                  <div key={fieldGroupName} className={classes.fieldGroup}>
                    <h5 className={classnames('headline-default', classes.toggleHeadline)} onClick={this.collapseSection(fieldGroupName)}>
                      <Tooltip title={openGroups[fieldGroupName] ? 'collapse' : 'show'}>
                        <Icon type="arrow-up" className={classes.collapseIcon} style={{ fontSize: '20px', transform: `rotate(${openGroups[fieldGroupName] ? '0' : '180deg'})`  }} /> &nbsp;
                      </Tooltip>

                      <span className={classes.headlineText}>{get(fieldsMap[fieldGroupName], 'name')}</span>
                    </h5>

                    <div style={{ display: openGroups[fieldGroupName] ? 'block' : 'none' }}>
                      <p className={classes.fieldGroupCheckAll}>
                        <Checkbox
                          indeterminate={!isCheckedAll && !isNotCheckedAll && true}
                          onChange={this.onCheckAllChange(fieldGroupName, isCheckedAll)}
                          checked={isCheckedAll}
                        >
                          <b>Check all</b>
                        </Checkbox>
                      </p>

                      {get(fieldsMap[fieldGroupName], 'fields', []).map(field => {
                        let isCheckedFieldAll = true;
                        if (get(field, 'permissions')) {
                          const value = this.props.form.getFieldValue(get(field, 'key'));

                          if (value && value.length !== field.permissions.length) { isCheckedFieldAll = false; }
                        }

                        return (
                          <div key={get(field, 'key')}>
                            {get(field, 'permissions') ? (<div>
                              <div className={classes.permissionsSelectWrapper}>
                                <label className={classes.permissionsSelectLabel}>
                                  <b>{get(field, 'name')}</b><br/>
                                  {getFieldDecorator(
                                    get(field, 'key'),
                                    { initialValue: get(field, 'permissions', []).map(permission => get(this.props, `${get(field, 'key')}_${permission.key}`) ? permission.key : false).filter(permission => !!permission) })(
                                    <Select
                                      mode="tags"
                                      placeholder="Please select"
                                      style={{ width: '100%' }}
                                    >
                                      {get(field, 'permissions').map(permission => (
                                        <Option key={permission.key} value={permission.key}>{permission.value}</Option>
                                      ))}
                                    </Select>
                                  )}
                                </label>
                                <span className={classes.checkField} onClick={this.onCheckField(get(field, 'key'), isCheckedFieldAll, get(field, 'permissions'))}>{isCheckedFieldAll ? 'Clear all' : 'Check all'}</span>
                              </div>
                              <br/>
                            </div>) : (<p>
                              {getFieldDecorator(get(field, 'key'), { initialValue: get(this.props, get(field, 'key'), false), valuePropName: 'checked' })(
                                <Checkbox disabled={!isEditable}>{get(field, 'name')}</Checkbox>,
                              )}
                            </p>)}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )
              })}
            </Col>
          </Row>


          {requestResult.type && (<Alert message={requestResult.message} type={requestResult.type} className={classes.submitResult} />)}

          <div className={classes.actionWrapper}>
            {isEditable && (<Form.Item>
              <Button type="primary" size="large" htmlType="submit" className={classes.submitButton}>
                Save
                {isLoading && <Icon type="loading" />}
              </Button>&nbsp; &nbsp;
            </Form.Item>)}

            <Button type="default" size="large" htmlType="button" className={classes.submitButton} onClick={this.props.onCancel}>
              Cancel
            </Button>
          </div>
        </Form>

        <Modal
          title={`Role ${this.state.roleState === 'inactive' ? 'Activate' : 'Deactivate'}`}
          visible={deactivateSubmitModal}
          onOk={this.toggleActivate}
          onCancel={this.hideDeactivateModal}
        >
          <p>Confirm role {this.state.roleState === 'inactive' ? 'activate' : 'deactivate'} action</p>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  roleCreatePermission: getRoleCreatePermission(state),
  roleUpdatePermission: getRoleUpdatePermission(state),
  roleDeletePermission: getRoleDeletePermission(state)
});

const mapDispatchToProps = { logout };

export default Form.create({ name: 'site' })(connect(mapStateToProps, mapDispatchToProps)(SettingsRoleForm));



// WEBPACK FOOTER //
// ./src/components/SettingsRoleForm/SettingsRoleForm.js